"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap/bnrplayer/_setup");
require("./bootstrap/bnrplayer/AccordionConfig");
require("./bootstrap/bnrplayer/AdConfig");
require("./bootstrap/bnrplayer/GoogleAnalyticsEventsConfig");
require("./bootstrap/bnrplayer/SocialSharingConfig");
require("./bootstrap/bnrplayer/PlayerConfig");
require("picturefill");
require("./tools/touchDetector");
require("./bootstrap/bnr/Eggs");
